import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme) => ({
    listContainer: {
      padding: 0,
    },
  }),
  {index: 1},
);

export default useStyles;
